import { useEffect, useState } from 'react';
import { deleteCenterCostFromApi, getCenterCostListByTypeFromApi } from '../../../../api/CenterCost/centerCosts';
import errorMessage from '../../../../helpers/errorMessage';
import CenterCostType from '../../../../types/Accounting/CenterCost/CenterCostType';
import { CenterCostData } from '../../../../types/Accounting/CenterCost/CenterCostTypes';

interface StateFilterData {
  [key: string]: string;
}

type UseCenterCostListList = {
  centerCosts: CenterCostData[];
  loading: boolean;
  errorListMessage: string | null;
  removeCenterCost: (id: number) => void;
};

const useCenterCostList = (centerCostType: CenterCostType): UseCenterCostListList => {
  const [centerCosts, setCenterCosts] = useState<CenterCostData[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [errorListMessage, setErrorListMessage] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setErrorListMessage(null);
    getCenterCostListByTypeFromApi(centerCostType.value())
      .then((center_costs: CenterCostData[]) => {
        if (!cancelled) {
          setCenterCosts(center_costs);
        }
      })
      .catch(error => {
        if (!cancelled) {
          setErrorListMessage(errorMessage(error));
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [centerCostType]);

  const removeCenterCost = (id: number) => {
    setLoading(true);
    setErrorListMessage(null);
    deleteCenterCostFromApi(centerCostType.value(), id)
      .then(() => setCenterCosts(centerCosts.filter((centerCost: CenterCostData) => centerCost.id !== id)))
      .catch(error => {
        setErrorListMessage(errorMessage(error));
      })
      .finally(() => setLoading(false));
  };

  return {
    centerCosts,
    loading,
    errorListMessage,
    removeCenterCost,
  };
};

export default useCenterCostList;
